import { render, staticRenderFns } from "./textarea-secondary.vue?vue&type=template&id=eee0aac0&scoped=true"
import script from "./textarea-secondary.vue?vue&type=script&lang=js"
export * from "./textarea-secondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee0aac0",
  null
  
)

export default component.exports